export type SurveyListResponseType = {
  surveys: SurveyType[]
}

export type SurveyResponseType = {
  survey: Required<SurveyType>
}

export type QuestionResponseType = {
  question: Partial<SurveyType>
}

export type SurveyType = {
  surveyId: string
  jpTitle: string
  viewStatus: number
  jpContent?: string
  rawContent?: string
  inputType?: 'none' | 'textArea' | 'selectBox'
  jpInputValue?: string[]
  isRequired?: number
  isFixed?: boolean
  // 新しいAPIのフィールドも追加（後方互換性のため）
  id?: string
  title?: { ja: string; en?: string; zh?: string; zhTw?: string; ko?: string }
  question_text?: { ja: string; en?: string; zh?: string; zhTw?: string; ko?: string }
  type?: 'score' | 'choice_single' | 'choice_multiple' | 'text' | 'nps'
  choices?: Array<{ ja: string; en?: string; zh?: string; zhTw?: string; ko?: string }>
  is_visible?: number
  sort_order?: number
}

/**
 * アンケート取得APIの関数型定義
 */
export type SurveyFetchType = (surveyId?: string) => Promise<SurveyResponseType | SurveyListResponseType | QuestionResponseType>

/**
 * 新しいAPIのレスポンスを既存の形式に変換する関数
 */
export const convertQuestionToSurvey = (question: any): SurveyType => {
  // questionがundefinedまたはnullの場合の処理
  if (!question) {
    return {
      surveyId: '',
      jpTitle: '',
      viewStatus: 0,
      jpContent: '',
      rawContent: '',
      inputType: 'selectBox',
      jpInputValue: [],
      isRequired: 0,
      isFixed: false,
      id: '',
      title: { ja: '' },
      question_text: { ja: '' },
      type: 'choice_single',
      choices: [],
      is_visible: 0,
      sort_order: 0,
    }
  }

  const converted: SurveyType = {
    surveyId: question.id || question.surveyId || '',
    jpTitle: question.title?.ja || question.jpTitle || '',
    viewStatus:
      question.isVisible !== undefined
        ? question.isVisible
          ? 1
          : 0
        : question.is_visible !== undefined
          ? question.is_visible
          : question.viewStatus || 0,
    jpContent: question.questionText?.ja || question.title?.ja || question.question_text?.ja || question.jpContent || '',
    rawContent: question.questionText?.ja || question.title?.ja || question.question_text?.ja || question.rawContent || '',
    inputType:
      question.type === 'score'
        ? 'none'
        : question.type === 'choice_single' || question.type === 'choice_multiple'
          ? 'selectBox'
          : question.type === 'text' || question.type === 'textarea'
            ? 'textArea'
            : question.inputType || 'selectBox',
    jpInputValue: question.choices?.map((choice: any) => choice.ja || choice.text || '') || question.jpInputValue || [],
    isRequired:
      question.isRequired !== undefined
        ? question.isRequired
        : question.is_required !== undefined
          ? question.is_required
          : question.isRequired || 0,
    isFixed:
      question.isFixed !== undefined
        ? Boolean(question.isFixed)
        : question.is_fixed !== undefined
          ? Boolean(question.is_fixed)
          : question.isFixed || false,
    // 新しいフィールドも保持
    id: question.id || '',
    title: question.title || {},
    question_text: question.questionText || question.title || {}, // questionTextを優先
    type: question.type || 'choice_single',
    choices: question.choices || [],
    is_visible: question.isVisible !== undefined ? (question.isVisible ? 1 : 0) : question.is_visible || 0,
    sort_order: question.sortOrder !== undefined ? question.sortOrder : question.sort_order || 0,
  }
  return converted
}
